<section class="detalhes">
    
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h4>{{ data.TITULO }}</h4>
            </div>
        </div>
        <p class="mb-3" *ngFor="let dado of data.DADOS">{{ dado.TEXTO }}</p>
    </div>

</section>